import { render, staticRenderFns } from "./setDeptDialog.vue?vue&type=template&id=62445c6d&scoped=true&"
import script from "./setDeptDialog.vue?vue&type=script&lang=js&"
export * from "./setDeptDialog.vue?vue&type=script&lang=js&"
import style0 from "./setDeptDialog.vue?vue&type=style&index=0&id=62445c6d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62445c6d",
  null
  
)

export default component.exports